export const navLinks = [
  { id: 'about', label: '平台简介' },
  { id: 'entrances', label: '入口类型' },
  { id: 'howto', label: '查找地址' },
  { id: 'antilost', label: '防走失' },
  { id: 'features', label: '内容特点' },
  { id: 'faq', label: '常见问题' },
];

export const heroHighlights = [
  {
    icon: 'ri-compass-3-line',
    title: '官网入口',
    desc: '从官方渠道进入，信息更新最及时',
  },
  {
    icon: 'ri-links-line',
    title: '最新地址',
    desc: '网络环境变化后对外公布的可用地址',
  },
  {
    icon: 'ri-megaphone-line',
    title: '发布页',
    desc: '集中公布入口变更与地址更新的页面',
  },
  {
    icon: 'ri-anchor-line',
    title: '永久入口',
    desc: '不易受地址变动影响、可长期使用',
  },
];

export const entranceTypes = [
  {
    id: 'official',
    icon: 'ri-shield-check-line',
    tag: '主入口',
    title: '官网入口',
    desc: '由平台自己公布、用于正常访问的主入口。它通常与官方说明、版本信息保持同步，适合作为日常访问的首选路径。',
    points: ['信息与平台说明保持一致', '适合作为日常访问首选', '优先从官方渠道获取'],
  },
  {
    id: 'latest',
    icon: 'ri-refresh-line',
    tag: '随环境更新',
    title: '最新地址',
    desc: '当原有入口受网络环境影响无法访问时，平台会对外公布新的可用地址。最新地址往往带有时间性，需要以官方最新公布为准。',
    points: ['会随网络环境变化而更新', '以官方最新公布为准', '不宜长期固守同一个地址'],
  },
  {
    id: 'domain',
    icon: 'ri-global-line',
    tag: '较稳定',
    title: '官方网址',
    desc: '平台对外公布的主域名称，通常相对稳定。记住官方网址有助于在入口变动时快速辨别真伪，避免进入仿冒页面。',
    points: ['相对稳定的对外主域', '用于辨别真伪与来源', '关注官方公布的字面信息'],
  },
  {
    id: 'release',
    icon: 'ri-megaphone-line',
    tag: '集中公布',
    title: '发布页',
    desc: '专门用于公布最新地址与入口变更的页面。它不承载内容本身，而是把「现在应该去哪个入口」讲清楚，是防走失的关键一环。',
    points: ['集中说明入口是否变更', '不承载内容本身', '适合定期回访查看'],
  },
  {
    id: 'antilost',
    icon: 'ri-bookmark-3-line',
    tag: '长期收藏',
    title: '防走失入口',
    desc: '便于长期收藏、跨设备访问的备用入口。把发布页与防走失入口一起保存，即使主入口临时变化，也能顺着线索找回来。',
    points: ['便于长期收藏与同步', '跨设备访问更省事', '与发布页配合使用'],
  },
  {
    id: 'permanent',
    icon: 'ri-anchor-line',
    tag: '长期有效',
    title: '永久入口',
    desc: '相对不易受地址变动影响、可以长期使用的入口形式。永久入口的意义在于「稳定可回」，帮助用户在地址更替时仍能找到官方去向。',
    points: ['强调长期可用与稳定', '地址更替时的找回线索', '以官方说明为准'],
  },
];

export const scenarioTabs = [
  {
    id: 'first',
    label: '首次访问',
    hint: '第一次来到本站，想知道该从哪里开始',
    steps: [
      {
        title: '先确认官方入口',
        desc: '从官方公布的渠道获取入口，不要轻信来路不明的短链与弹窗广告，避免误入仿冒页面。',
      },
      {
        title: '了解入口类型差异',
        desc: '分清官网入口、最新地址、发布页与永久入口各自的用途，再决定平时收藏哪一个。',
      },
      {
        title: '收藏发布页与防走失入口',
        desc: '把发布页和防走失入口一起加入收藏夹，为后续地址变化提前留好退路。',
      },
    ],
  },
  {
    id: 'daily',
    label: '日常访问',
    hint: '已经用过一段时间，想保持稳定访问',
    steps: [
      {
        title: '优先使用官网入口',
        desc: '日常访问以官网入口为主，信息最及时，也最不容易遇到失效页面。',
      },
      {
        title: '定期回访发布页',
        desc: '每隔一段时间看一眼发布页，确认入口是否发生变更，做到心里有数。',
      },
      {
        title: '多端同步收藏',
        desc: '把入口在电脑与手机端都保存一份，换设备时不用重新搜索。',
      },
    ],
  },
  {
    id: 'lost',
    label: '地址失效时',
    hint: '原入口打不开了，想快速找回',
    steps: [
      {
        title: '不要急着换搜索引擎碰运气',
        desc: '优先回到你此前保存的发布页或防走失入口，那里的信息更能反映当前真实入口。',
      },
      {
        title: '按线索逐层查找',
        desc: '从发布页的最新说明出发，找到当前对外公布的最新地址，再回到官网入口。',
      },
      {
        title: '更新你的收藏',
        desc: '找回后第一时间更新收藏与书签，避免下次再遇到同样的困扰。',
      },
    ],
  },
];

export const antiLostTips = [
  {
    icon: 'ri-bookmark-3-line',
    title: '收藏发布页而非单一地址',
    desc: '单一地址说变就变，发布页才是「入口的入口」。把它放进收藏夹第一位，找回时更省心。',
  },
  {
    icon: 'ri-device-line',
    title: '电脑与手机各存一份',
    desc: '浏览器书签、备忘录、云笔记都可以，多端各留一份，换设备时不必重新搜索。',
  },
  {
    icon: 'ri-archive-line',
    title: '留下可追溯的线索',
    desc: '把入口来源、更新时间与官方说明一起记下来，方便日后辨别真伪，避免被仿冒页面误导。',
  },
  {
    icon: 'ri-eye-line',
    title: '辨别页面真伪',
    desc: '留意页面信息是否与官方说明一致，警惕要求额外下载、填写无关信息的页面。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '定期回访确认',
    desc: '每隔一段时间回访发布页，确认入口是否变化，养成「定期看一眼」的习惯。',
  },
  {
    icon: 'ri-share-forward-line',
    title: '谨慎转发来源',
    desc: '从不明来源转发的入口链接往往经不起核对，优先使用自己长期保存的官方线索。',
  },
];

export const features = [
  {
    icon: 'ri-film-line',
    title: '影视内容聚合',
    desc: '以影视资源聚合为核心方向，围绕影片与剧集提供浏览入口，方便用户按兴趣查找想看的内容。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '分类与频道',
    desc: '按类型、地区、年份等维度组织内容，让不同喜好的用户都能较快定位到合适的方向。',
  },
  {
    icon: 'ri-search-line',
    title: '便捷查找',
    desc: '提供站内查找方式，减少在大量条目中反复翻找的时间，尽快靠近你想看的内容。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '桌面端与移动端都能顺畅浏览，页面结构随屏幕调整，手机上同样可以轻松阅读。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新节奏',
    desc: '入口与页面信息会随实际情况调整，关注发布页可以及时了解有哪些变化。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '防走失设计',
    desc: '围绕入口稳定性提供多重线索，让用户在地址更替时依然能够找到官方的去向。',
  },
];

export const faqs = [
  {
    q: '茶杯狐影视最新地址为什么会发生变化？',
    a: '入口地址有时会受网络环境、域名调整等因素影响而变化。因此平台通常会通过发布页等方式对外公布当前可用的最新地址，使用时以官方最新公布的信息为准，而不是固守某一个旧地址。',
  },
  {
    q: '如何判断官网入口是否可靠？',
    a: '优先从官方公布的渠道获取入口，并核对页面信息是否与官方说明一致。对来自陌生私信、弹窗广告或不明短链的入口保持谨慎，遇到要求额外下载或填写无关信息的情况更应提高警惕。',
  },
  {
    q: '发布页和永久入口有什么区别？',
    a: '发布页是「集中公布入口信息」的页面，重点在于告诉你当前该去哪里；永久入口则强调长期可用与稳定，便于地址更替时仍能找回来。两者配合使用，防走失效果更好。',
  },
  {
    q: '官网入口打不开时应该怎么处理？',
    a: '建议先回到自己此前保存的发布页或防走失入口，按上面的最新说明逐层查找当前对外公布的地址，找回后及时更新收藏。不建议盲目在搜索引擎里碰运气，以免进入仿冒页面。',
  },
  {
    q: '浏览本页需要注册账号或付费吗？',
    a: '本站是一个说明平台入口与最新地址相关信息的单页站点，不提供账号系统，也不进行任何收费或提交操作。页面中的内容仅为入口信息的整理与说明。',
  },
  {
    q: '怎样做才能长期不迷路？',
    a: '把发布页与防走失入口一起收藏，并在电脑与手机端各保存一份；同时养成定期回访发布页、确认入口是否变化的习惯。留有可追溯的线索，是防走失最有效的方式。',
  },
];

export const notices = [
  {
    icon: 'ri-link-m',
    title: '以官方公布为准',
    desc: '入口与地址信息具有时效性，请以平台官方最新公布的内容为准，不要长期使用来源不明的链接。',
  },
  {
    icon: 'ri-alert-line',
    title: '警惕仿冒页面',
    desc: '对要求额外下载、索取无关个人信息的页面保持警惕，发现信息与官方说明不符时应及时退出。',
  },
  {
    icon: 'ri-information-line',
    title: '内容仅为信息整理',
    desc: '本站所呈现的入口类型与查找方法为一般性说明，具体可用性可能随实际情况变化。',
  },
];

export const relatedTerms = [
  '茶杯狐影视',
  '茶杯狐影视最新地址',
  '茶杯狐影视官网入口',
  '茶杯狐影视官方网址',
  '茶杯狐影视发布页',
  '茶杯狐影视防走失',
  '茶杯狐影视永久入口',
];